import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';

var Breadcrumbs = function Breadcrumbs(_ref) {
  var crumbs = _ref.crumbs,
      active = _ref.active,
      emptyState = _ref.emptyState,
      children = _ref.children,
      LinkTag = _ref.linkTag,
      homeUrl = _ref.homeUrl,
      rest = _objectWithoutPropertiesLoose(_ref, ["crumbs", "active", "emptyState", "children", "linkTag", "homeUrl"]);

  var renderBreadCrumb = function renderBreadCrumb(crumb) {
    // default breadcrumbitem render
    var breadCrumbItemChildren = React.createElement("span", null, emptyState); // render static links

    if (crumb.name && crumb.url) {
      breadCrumbItemChildren = React.createElement(LinkTag, {
        "aria-label": crumb.name,
        href: crumb.url
      }, crumb.name);
    }

    return React.createElement(BreadcrumbItem, {
      key: crumb.name + crumb.url
    }, breadCrumbItemChildren);
  };

  return React.createElement(Breadcrumb, rest, React.createElement(BreadcrumbItem, null, React.createElement(LinkTag, {
    "aria-label": "Home",
    href: homeUrl
  }, "Home")), crumbs && crumbs.length > 0 && crumbs.map(renderBreadCrumb), children, React.createElement(BreadcrumbItem, {
    active: true
  }, active || emptyState));
};

Breadcrumbs.defaultProps = {
  emptyState: '…',
  homeUrl: '/public/apps/dashboard',
  linkTag: 'a'
};
export default Breadcrumbs;